import type { AnchorHTMLAttributes, MouseEvent } from "react";
import { Link as RouterLink } from "react-router-dom";

type Props = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  href: string | { pathname?: string };
};

export default function Link({ href, onClick, ...props }: Props) {
  const to = typeof href === "string" ? href : href.pathname || "/";
  if (/^(https?:|mailto:|tel:|#)/.test(to)) return <a href={to} onClick={onClick} {...props} />;
  return (
    <RouterLink
      to={to}
      onClick={onClick as ((event: MouseEvent<HTMLAnchorElement>) => void) | undefined}
      {...props}
    />
  );
}
